<template>
  <TheLayout type="base">
    <main class="index-view container">
      <InsuranceProcess
        id="process"
        class="index-view__section"
        :showModalSubsciptionCancel="showModalSubsciptionCancel"
        @close-cancel-modal="showModalSubsciptionCancel = false"
      />
      <SectionLayout
          class="index-view__section slider-viewport"
          title-bottom-margin-size="big"
          is-call-to-action
          >
          <CustomLogoSlider :items="partnerLogos" />
      </SectionLayout>
      <SectionLayout
          class="index-view__section" 
          title="Оформить легко" 
          bg-theme="primary-invert"
          title-bottom-margin-size="big"
          >
          <ExecutionSteps />
      </SectionLayout>
      <SectionLayout class="index-view__section" 
          title="Что будет застраховано" 
          bg-theme="primary-invert"
          >
          <InsuranceTargets />
      </SectionLayout>
      <SectionLayout id="advantages"
          class="index-view__section" 
          title="Преимущества страхования для бизнеса" 
          bg-theme="primary-invert"
          title-bottom-margin-size="big"
          >
          <BusinessAdvantages />
      </SectionLayout>
      <SectionLayout class="index-view__section" 
          bg-theme="primary"
          bg-with-image
          is-call-to-action
          >
          <CallToAction title="Оформите полис в течение 1 минуты"
              submit-button-text="Оформить полис"
              :submit-button-callback="callToActionCallback" />
      </SectionLayout>
      <!-- Временно убрано
      <SectionLayout id="faq"
          class="index-view__section" 
          title="Узнать больше"
          bg-theme="primary-invert"
          >
          <TheFaq
          />
      </SectionLayout> -->
      <SectionLayout class="index-view__section" 
          title="Как получить компенсацию"
          bg-theme="primary-invert"
          >
          <CompensationSteps />
      </SectionLayout>
      <SectionLayout class="index-view__section" 
          bg-theme="primary-invert" 
          title="Оставьте заявку"
          title-bottom-margin-size="big"
          :current-step="0" 
          halved-content
          >
          <ModalRequestCall
            ref="feedbackFormSectionRef" 
            :display-as-section="true"
            title="Оформим полис вместе"
            text="Заполните форму ниже, и мы поможем вам оформить полис, не выходя из дома."
            button-text="Отправить заявку"
            :is-submitting="isFeedbackSubmitting"
            @request-call-submit="handleFeedbackFormSubmit"
          />
          <template #aside-content>
            <div class="feedback-image-container">
              <img src="@/assets/images/feedback-image.jpg" alt="Обратная связь" class="feedback-image">
            </div>
            <p v-if="feedbackSubmitStatus && !feedbackSubmitSuccess" class="feedback-form__status submit-error">
              {{ feedbackSubmitStatus }}
            </p>
          </template>
      </SectionLayout>
      <SectionLayout
          class="index-view__section" 
          title="Актуальные предложения" 
          bg-theme="primary-invert"
          title-bottom-margin-size="big"
          >
          <CurrentOffers />
      </SectionLayout>
      <SectionLayout
          class="index-view__section" 
          title="У нас также ищут" 
          bg-theme="primary-invert"
          title-bottom-margin-size="big"
          >
          <BankList />
      </SectionLayout>
    </main>

    <ModalPolicyIssuanceSuccess
      :visible="showPolicyIssuanceSuccessModal"
      modal-width="719px"
      @close="showPolicyIssuanceSuccessModal = false" />
      <ModalRequestCallSuccess
      :visible="showFeedbackSuccessModal"
      modal-width="719px"
      @close="showFeedbackSuccessModal = false"
    />
  </TheLayout>
</template>

<script>
import TheLayout from '@/components/layouts/TheLayout';
import SectionLayout from '@/components/layouts/SectionLayout';
import InsuranceProcess from '@/components/pages/index/InsuranceProcess';
import ModalPolicyIssuanceSuccess from '@/components/modals/ModalPolicyIssuanceSuccess';
import ExecutionSteps from '@/components/pages/index/ExecutionSteps';
import InsuranceTargets from '@/components/pages/index/InsuranceTargets';
import CurrentOffers from '@/components/pages/index/CurrentOffers';
import BankList from '@/components/pages/index/BankList';
import CallToAction from '@/components/pages/index/CallToAction';
import ModalRequestCallSuccess from '@/components/modals/ModalRequestCallSuccess';
import BusinessAdvantages from '@/components/pages/index/BusinessAdvantages';
import TheFaq from '@/components/pages/index/TheFaq';
import CompensationSteps from '@/components/pages/index/CompensationSteps';
import CustomLogoSlider from '@/components/pages/index/CustomLogoSlider';
import { GLOBAL_MODAL_KEYS_MAP } from '@/consts';
import ModalRequestCall from '@/components/modals/ModalRequestCall'; 
import { submitRequestCall } from '@/api/request-service';

import scrollTo from '@/mixins/scrollTo';

export default {
  name: 'IndexView',
  components: {
    ModalPolicyIssuanceSuccess,
    TheLayout,
    ModalRequestCallSuccess,
    CurrentOffers,
    BankList,
    ExecutionSteps,
    BusinessAdvantages,
    InsuranceTargets,
    CallToAction,
    TheFaq,
    CompensationSteps,
    ModalRequestCall,
    CustomLogoSlider,
    SectionLayout,
    InsuranceProcess,
  },
  mixins: [scrollTo],
  data() {
    return {
      isFeedbackSubmitting: false,
      feedbackSubmitStatus: '', 
      feedbackSubmitSuccess: false,
      showFeedbackSuccessModal: false,
      showPolicyIssuanceSuccessModal: false,
      showModalSubsciptionCancel: false,
      partnerLogos: [
        { text: 'до 20 000 000₽',desc:'Страховые выплаты', iconName: 'money' }, 
        { text: 'от 680₽',desc:'Стоимость', iconName: 'app' },      
        { text: 'онлайн 24/7',desc:'Оформление', iconName: 'shield-tick' },
        { text: 'поддержка 24/7',desc:'Всегда на связи', iconName: 'support-24' }, 
        { text: 'полис за 5 минут',desc:'Быстро', iconName: 'edit-pen' },
      ],
    }
  },
  methods: {
    callToActionCallback() {
      this.scrollTo('process')
    },
    async handleFeedbackFormSubmit(formData) {
      console.log('[IndexView] handleFeedbackFormSubmit вызван с данными:', formData);
      this.isFeedbackSubmitting = true;
      this.feedbackSubmitStatus = '';
      this.feedbackSubmitSuccess = false;

      try {
        const contextData = {
        };

        const response = await submitRequestCall(formData, contextData, 'static_feedback_form');

        if (response && response.result) { 
          this.showFeedbackSuccessModal = true;

          
          if (this.$refs.feedbackFormSectionRef) {
            console.log('[IndexView] Попытка вызова resetFormFields на ref:', this.$refs.feedbackFormSectionRef);
            this.$refs.feedbackFormSectionRef.resetFormFields();
          } else {
            console.warn('[IndexView] feedbackFormSectionRef недоступен для вызова resetFormFields.');
          }
        } else {
          console.error('Static Feedback form submission error from API:', response);
          this.feedbackSubmitSuccess = false;
          this.feedbackSubmitStatus = 'Произошла ошибка при отправке (ответ сервера). Пожалуйста, попробуйте еще раз.';
        }

      } catch (error) {
        console.error('Static Feedback form submission error (catch block):', error);
        this.feedbackSubmitSuccess = false;
        this.feedbackSubmitStatus = 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.';
      } finally {
        this.isFeedbackSubmitting = false;
      }
    },
  },
  created() {
    document.title = 'Страхование ипотеки: калькулятор стоимости ипотечного страхования, расчет цены онлайн';

    let metaDescription = document.querySelector("meta[name='description']");

    if (!metaDescription) {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = 'description';
      const description = 'Онлайн калькулятор страхования ипотеки, рассчитать стоимость ипотечного страхования квартиры или другой недвижимости в Зетта Страхование. Узнать стоимость и оформить страховку при ипотеке в 2024 году для Сбербанк ВТБ Газпромбанк Промсвязьбанк Совкомбанк Уралсиб Дом.РФ Райфайзенбанк. Удобные способы оплаты.';
      newMetaDescription.content = description;
      document.head.appendChild(newMetaDescription);
    }
  },
  mounted() {
    const { message } = this.$route.query;

    switch (message) {
      case GLOBAL_MODAL_KEYS_MAP.successPolicyIssuance:
        this.showPolicyIssuanceSuccessModal = true;
        break;
      default:
        break;
    }
  }
}
</script>

<style scoped lang="scss">
.feedback-form__status {
  margin-top: 15px;
  text-align: center;
  width: 100%; 
}

.submit-success {
  color: green;
}

.submit-error {
  color: red;
}
.slider-viewport {
  overflow: hidden;
}
.index-view {
  &__section {
    &:nth-child(2) {
      padding: 0;
    }
    $vertical-margin-desktop: $gap-large;
    $vertical-margin-desktop-min: 40px;

    @include resetting-vertical-indentation-of-first;

    margin-top: rem($vertical-margin-desktop);

    @media (#{$screen-big}) {
      margin-top: rem($vertical-margin-desktop-min);
    }
  }
}
.feedback-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.feedback-image {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: $border-radius-medium; 
}
</style>
